const indexItems = [
  { icon: 'ri-movie-2-line', label: '妖精视频专区', count: '2.8万+', color: 'primary' },
  { icon: 'ri-vidicon-line', label: '桃花视频专区', count: '2.1万+', color: 'accent' },
  { icon: 'ri-film-line', label: '苹果视频专区', count: '1.9万+', color: 'secondary' },
  { icon: 'ri-play-list-2-line', label: '榴莲视频专区', count: '1.7万+', color: 'primary' },
  { icon: 'ri-live-line', label: '豆花视频专区', count: '1.5万+', color: 'accent' },
  { icon: 'ri-clapperboard-line', label: '菠萝视频专区', count: '1.3万+', color: 'secondary' },
  { icon: 'ri-slideshow-line', label: '红杏视频专区', count: '1.1万+', color: 'primary' },
  { icon: 'ri-tv-2-line', label: '影视大全新片', count: '9.8千+', color: 'accent' },
  { icon: 'ri-stack-line', label: '热门视频合集', count: '8.5千+', color: 'secondary' },
];

export default function IndexSection() {
  return (
    <section id="index" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-10 md:mb-14">
            <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950">视频索引</h2>
            <p className="mt-3 text-sm md:text-base text-foreground-500 max-w-lg mx-auto">
              按视频平台分类浏览，热门视频合集直达入口一触即达
            </p>
          </div>

          <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-3 gap-4 md:gap-5">
            {indexItems.map((item, i) => {
              const colorClasses = item.color === 'primary'
                ? { bg: 'bg-primary-100', icon: 'text-primary-600', hover: 'hover:border-primary-200/60 hover:bg-primary-50/50' }
                : item.color === 'accent'
                ? { bg: 'bg-accent-100', icon: 'text-accent-600', hover: 'hover:border-accent-200/60 hover:bg-accent-50/50' }
                : { bg: 'bg-secondary-100', icon: 'text-secondary-600', hover: 'hover:border-secondary-200/60 hover:bg-secondary-50/50' };

              return (
                <div
                  key={i}
                  className={`group rounded-xl bg-background-50 border border-background-200/70 p-4 md:p-5 flex items-center gap-4 cursor-pointer transition-all duration-300 ${colorClasses.hover}`}
                >
                  <div className={`w-11 h-11 rounded-xl ${colorClasses.bg} flex items-center justify-center flex-shrink-0 group-hover:scale-110 transition-transform duration-300`}>
                    <i className={`${item.icon} text-lg ${colorClasses.icon}`}></i>
                  </div>
                  <div className="min-w-0">
                    <h3 className="text-sm font-semibold text-foreground-900 truncate">{item.label}</h3>
                    <p className="text-xs text-foreground-500 mt-0.5">{item.count} 资源</p>
                  </div>
                  <i className="ri-arrow-right-s-line text-foreground-300 ml-auto flex-shrink-0 group-hover:text-primary-500 transition-colors"></i>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}